import React from 'react'
import { ExternalLinkIcon } from '@heroicons/react/outline';
import propTypes from 'prop-types';

export default function CardDocument({title,date,writer,onClick}) {
  return (
    <div className="p-5 transition-all duration-300 cursor-pointer wrapper hover:bg-cardFeaturesHover rounded-2xl group"
      onClick={onClick}
    >
      <h1 className="text-sm font-medium text xl:text-xl title text-articleTitle group-hover:text-primary">
        {title}
      </h1>
      <div className="flex items-center justify-between mt-5 space-x-2 text-xs xl:font-normal cardFooter text-cardText ">
        <div className='flex space-x-2'>
          <span>{date.substring(0, 10)
                    .split("-")
                    .reverse()
                    .join("-")}</span>
          <div className="line">|</div>
          <span>{writer}</span>
        </div>
        <ExternalLinkIcon className='hidden w-6 h-6 transition-all duration-300 text-primary group-hover:block'/>
      </div>
    </div>
  );
}

CardDocument.propTypes = {
  title: propTypes.string,
  date: propTypes.string,
  writer: propTypes.string,
  onClick: propTypes.func,
}
